import { ColumnFilterElementTemplateOptions } from "primereact/column";
import { MultiSelect, MultiSelectChangeEvent } from "primereact/multiselect";
import { useCallback, useMemo } from "react";
import { useAppSelector } from "../../hooks/storeHooks";
import { selectInspectionEnableLowPriorityDefects } from "../../store/selectors/inspectionSelectors";

export const PriorityFilter = (options: ColumnFilterElementTemplateOptions) => {
    const enableLowPriorityDefects = useAppSelector(
        selectInspectionEnableLowPriorityDefects
    );

    const priorityOptions = useMemo(() => {
        const options = [
            { label: "High", value: 2 },
            { label: "Medium", value: 3 }
        ];

        if (enableLowPriorityDefects) {
            options.push({ label: "Low", value: 5 });
        }

        return options;
    }, [enableLowPriorityDefects]);

    const onChange = useCallback(
        (e: MultiSelectChangeEvent) => {
            options.filterApplyCallback(e.value);
        },
        [options]
    );

    return (
        <MultiSelect
            value={options.value}
            options={priorityOptions}
            onChange={onChange}
            showClear
            filter
            placeholder="Show all"
            scrollHeight="400px"
            style={{ width: 132 }}
        />
    );
};
